"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ALPHACOUNT = 26;
var NavArrow_1 = __importDefault(require("./NavArrow/NavArrow"));
var CenterRange_1 = __importDefault(require("./CenterRange/CenterRange"));
var LeftBoundary_1 = __importDefault(require("./LeftBoundary/LeftBoundary"));
var RightBoundary_1 = __importDefault(require("./RightBoundary/RightBoundary"));
var DisplayDetails_1 = __importDefault(require("./DisplayDetails/DisplayDetails"));
var DisplayOptions_1 = __importDefault(require("./DisplayOptions/DisplayOptions"));
var ResponsiveHelper_1 = __importDefault(require("../ResponsiveHelper/ResponsiveHelper"));
var PaginationRender = /** @class */ (function (_super) {
    __extends(PaginationRender, _super);
    function PaginationRender(props) {
        var _this = _super.call(this, props) || this;
        _this.genLeftBoundary = function (startRange) {
            var leftEllipsisToggle = _this.state.leftEllipsisToggle;
            var _a = _this.props, alphabetical = _a.alphabetical, expandEllipsis = _a.expandEllipsis, disabledPages = _a.disabledPages;
            var firstItemInRange = _this.activeBoundary(startRange)[1];
            if (_this.currentPosition() > _this.range || firstItemInRange > 3) {
                return (React.createElement(LeftBoundary_1.default, { isActive: _this.isActive, alphabetical: alphabetical, lastOption: firstItemInRange, expandEllipsis: expandEllipsis, ellipsisToggle: leftEllipsisToggle, isPageDisabled: _this.isPageDisabled, onPageChangeHandle: _this.onPageChangeHandle, disabledPages: disabledPages ? _this.disablePagesIntArray() : null, onEllipsisClick: function () { return _this.setState({ leftEllipsisToggle: !leftEllipsisToggle }); } }));
            }
            else {
                return null;
            }
        };
        _this.activeBoundary = function (startRange) {
            var values = [];
            var maxPages = startRange === 0 ? _this.range : startRange + _this.range;
            for (var index = startRange; index < maxPages; index++) {
                values.push(index);
            }
            return values;
        };
        _this.genRightBoundary = function (startRange) {
            var rightEllipsisToggle = _this.state.rightEllipsisToggle;
            var _a = _this.props, alphabetical = _a.alphabetical, expandEllipsis = _a.expandEllipsis, disabledPages = _a.disabledPages;
            var pages = _this.activeBoundary(startRange);
            var lastPosition = pages[pages.length - 1];
            if (startRange + 1 <= _this.totalPages() - _this.range) {
                return (React.createElement(RightBoundary_1.default, { isActive: _this.isActive, alphabetical: alphabetical, totalPages: _this.totalPages(), lastPageInRange: lastPosition, expandEllipsis: expandEllipsis, ellipsisToggle: rightEllipsisToggle, isPageDisabled: _this.isPageDisabled, onPageChangeHandle: _this.onPageChangeHandle, disabledPages: disabledPages ? _this.disablePagesIntArray() : null, onEllipsisClick: function () { return _this.setState({ rightEllipsisToggle: !rightEllipsisToggle }); } }));
            }
            else {
                return null;
            }
        };
        _this.onPageChangeHandle = function (position, numberPerPage) {
            var _a = _this.props, onPageChange = _a.onPageChange, alphabetical = _a.alphabetical, itemsPerPage = _a.itemsPerPage;
            var newPagePosition = alphabetical ? String.fromCharCode(97 + position - 1) : position;
            if (position > 0 && position <= _this.totalPages()) {
                _this.setState({ position: position });
                var newItemsPerPage = numberPerPage ? numberPerPage : itemsPerPage;
                return onPageChange && onPageChange(newPagePosition, newItemsPerPage);
            }
        };
        _this.genClasses = function () {
            var _a = _this.props, className = _a.className, showNav = _a.showNav;
            var classes = "ui pagination";
            if (className) {
                classes += ' ' + className;
            }
            if (!showNav) {
                classes += ' hide-nav';
            }
            return classes;
        };
        _this.onRightNavClick = function () {
            var nextPage = _this.currentPosition() + 1;
            if (_this.props.disabledPages) {
                var ascendingArray = _this.disablePagesIntArray().sort(function (a, b) { return a - b; });
                ascendingArray.forEach(function (disablePage) {
                    nextPage = nextPage === disablePage ? nextPage + 1 : nextPage;
                });
            }
            _this.onPageChangeHandle(nextPage);
        };
        _this.onLeftNavClick = function () {
            var nextPage = _this.currentPosition() - 1;
            if (_this.props.disabledPages) {
                var descendingArray = _this.disablePagesIntArray().sort(function (a, b) { return b - a; });
                descendingArray.forEach(function (disablePage) {
                    nextPage = nextPage === disablePage ? nextPage - 1 : nextPage;
                });
            }
            _this.onPageChangeHandle(nextPage);
        };
        _this.isActive = function (value) {
            return _this.currentPosition() === value ? 'active' : '';
        };
        _this.totalPages = function () {
            var _a = _this.props, alphabetical = _a.alphabetical, totalItems = _a.totalItems, itemsPerPage = _a.itemsPerPage;
            if (alphabetical) {
                return ALPHACOUNT;
            }
            else {
                return Math.ceil(totalItems / itemsPerPage);
            }
        };
        _this.getStartRange = function () {
            var lastNumberInRange = _this.totalPages() - _this.range;
            var startRange = 0;
            if (_this.currentPosition() >= _this.range) {
                startRange = _this.currentPosition() - Math.round(_this.range / 2);
            }
            if (_this.currentPosition() <= _this.range) {
                startRange = 0;
            }
            if (_this.currentPosition() >= lastNumberInRange + 1) {
                startRange = lastNumberInRange;
            }
            return startRange;
        };
        _this.currentPosition = function () {
            var activePage = _this.props.activePage;
            if (activePage) {
                if (typeof activePage === 'string') {
                    return activePage.charCodeAt(0) - 96;
                }
                else {
                    return activePage;
                }
            }
            else {
                return _this.state.position;
            }
        };
        _this.breakpointsWidthCheck = function (points) {
            !points.m ? _this.setState({ compressed: true }) : _this.setState({ compressed: false });
        };
        _this.isPageDisabled = function (page) {
            var disabledPages = _this.props.disabledPages;
            var isDisabled = false;
            if (disabledPages) {
                var disablePageFound = disabledPages.find(function (disabledPage) {
                    if (typeof disabledPage === 'string' && typeof page === 'string') {
                        return disabledPage.toLowerCase() === page.toLowerCase();
                    }
                    else {
                        return disabledPage === page;
                    }
                });
                isDisabled = disablePageFound ? true : false;
            }
            return isDisabled;
        };
        _this.disablePagesIntArray = function () {
            var valueArray = [];
            _this.props.disabledPages.forEach(function (page) {
                if (typeof page === 'string') {
                    valueArray.push(page.toLowerCase().charCodeAt(0) - 96);
                }
                else {
                    valueArray.push(page);
                }
            });
            return valueArray;
        };
        _this.filterdRange = function () {
            var activeBoundary = _this.activeBoundary(_this.getStartRange());
            var sortedDisablePages = _this.disablePagesIntArray().sort(function (a, b) { return a - b; });
            return activeBoundary.filter(function (page) { return sortedDisablePages.indexOf(page + 1) < 0; });
        };
        _this.leftNavDisabled = function () {
            if (_this.props.disabledPages) {
                var lastValueInFirstRange = _this.range;
                var firstNonDisabledPage = _this.filterdRange()[0] + 1;
                return _this.currentPosition() === firstNonDisabledPage && _this.currentPosition() < lastValueInFirstRange ? true : false;
            }
            else {
                return _this.currentPosition() === 1 ? true : false;
            }
        };
        _this.rightNavDisabled = function () {
            if (_this.props.disabledPages) {
                var firstValeInLastRange = _this.totalPages() - _this.range;
                var lastNonDisabledPage = _this.filterdRange()[_this.filterdRange().length - 1] + 1;
                return _this.currentPosition() === lastNonDisabledPage && _this.currentPosition() > firstValeInLastRange ? true : false;
            }
            else {
                return _this.currentPosition() === _this.totalPages() ? true : false;
            }
        };
        _this.state = {
            position: 1,
            rightEllipsisToggle: false,
            leftEllipsisToggle: false,
            compressed: false
        };
        return _this;
    }
    PaginationRender.prototype.componentDidMount = function () {
        if (this.props.disabledPages) {
            var filteredActiveBoundary = this.filterdRange()[0] + 1;
            this.setState({ position: filteredActiveBoundary });
        }
    };
    PaginationRender.prototype.render = function () {
        var _this = this;
        var _a = this.props, showDisplayDetails = _a.showDisplayDetails, boundaryRange = _a.boundaryRange, showNav = _a.showNav, itemsPerPageOptions = _a.itemsPerPageOptions, itemsPerPageAllEnabled = _a.itemsPerPageAllEnabled, itemsPerPage = _a.itemsPerPage, totalItems = _a.totalItems, alphabetical = _a.alphabetical;
        var compressed = this.state.compressed;
        if (this.totalPages() - boundaryRange <= 2) {
            this.range = this.totalPages();
        }
        else if (boundaryRange <= 2) {
            this.range = 3;
        }
        else {
            this.range = boundaryRange;
        }
        var startRange = this.getStartRange();
        var currentPosition = this.currentPosition();
        var totalItemsPerPage = currentPosition * itemsPerPage;
        var firstItemInCurrentPage = totalItemsPerPage - (itemsPerPage - 1);
        var lastItemInCurrentPage = totalItemsPerPage > totalItems ? totalItems : totalItemsPerPage;
        var displayOptions = itemsPerPageOptions && !alphabetical && itemsPerPage && !compressed;
        var displayDetails = showDisplayDetails && !alphabetical && itemsPerPage && !compressed;
        return (React.createElement("div", { className: this.genClasses() },
            displayDetails &&
                React.createElement(DisplayDetails_1.default, { totalItems: totalItems, firstItemInCurrentPage: firstItemInCurrentPage, lastItemInCurrentPage: lastItemInCurrentPage }),
            React.createElement("div", { className: "nav-container" },
                showNav &&
                    React.createElement(NavArrow_1.default, { direction: "left", isDisabled: this.leftNavDisabled(), onClick: function () { return _this.onLeftNavClick(); } }),
                this.genLeftBoundary(startRange),
                React.createElement(CenterRange_1.default, { isActive: this.isActive, alphabetical: alphabetical, isPageDisabled: this.isPageDisabled, onPageChangeHandle: this.onPageChangeHandle, centerRange: this.activeBoundary(startRange) }),
                this.genRightBoundary(startRange),
                showNav &&
                    React.createElement(NavArrow_1.default, { direction: "right", isDisabled: this.rightNavDisabled(), onClick: function () { return _this.onRightNavClick(); } })),
            displayOptions &&
                React.createElement(DisplayOptions_1.default, { totalItems: totalItems, defaultOption: itemsPerPage, itemsPerPageOptions: itemsPerPageOptions, itemsPerPageAllEnabled: itemsPerPageAllEnabled, onPageChangeHandle: function (itemPerPage) { return _this.onPageChangeHandle(1, itemPerPage); } }),
            React.createElement(ResponsiveHelper_1.default, { activeBreakPoints: this.breakpointsWidthCheck })));
    };
    return PaginationRender;
}(React.Component));
exports.default = PaginationRender;
